import React from 'react';
import Transactions from '.';

const PayoutTransactions = () => (
  <>
    <Transactions
      title="Disbursement Transactions"
      transactionType="DISBURSEMENT"
    />
  </>
);

export default PayoutTransactions;
